<template>
  <div class="container-summary">
    <div class="container-summary__items">
      <div class="container-summary__item">
        <i class="el-icon-box container-summary__icon is-volume" />
        <span class="container-summary__label">{{ $l('label_total_volume') || '总体积' }}</span>
        <span class="container-summary__value">
          {{ summaryTotalVolume }} / {{ summaryTotalVolumeLimit }}
          <span class="container-summary__unit"> m³</span>
        </span>
        <span class="container-summary__pct">{{ summaryVolumePct }}%</span>
      </div>
      <div class="container-summary__divider" />
      <div class="container-summary__item">
        <i class="el-icon-data-line container-summary__icon is-weight" />
        <span class="container-summary__label">{{ $l('label_total_gross_weight') || '总毛重' }}</span>
        <span class="container-summary__value">
          {{ summaryTotalGrossWeight }} / {{ summaryTotalWeightLimit }}
          <span class="container-summary__unit"> kg</span>
        </span>
        <span class="container-summary__pct">{{ summaryWeightPct }}%</span>
      </div>
      <div class="container-summary__divider" />
      <div class="container-summary__item">
        <i class="el-icon-goods container-summary__icon" />
        <span class="container-summary__label">{{ $l('label_container_count') || '货柜' }}</span>
        <span class="container-summary__value">{{ data.length }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { add, round, divide, multiply } from '@/libs/util.number'

export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  computed: {
    summaryTotalVolume() {
      return round(
        this.data.reduce((sum, item) => add(sum, item.containerVolume || 0), 0),
        2
      )
    },
    summaryTotalGrossWeight() {
      return round(
        this.data.reduce((sum, item) => add(sum, item.containerGrossWeight || 0), 0),
        2
      )
    },
    summaryTotalVolumeLimit() {
      return round(
        this.data.reduce((sum, item) => add(sum, item.volumeLimit || 0), 0),
        2
      )
    },
    summaryTotalWeightLimit() {
      return round(
        this.data.reduce((sum, item) => add(sum, item.weightLimit || 0), 0),
        2
      )
    },
    summaryVolumePct() {
      if (!this.summaryTotalVolumeLimit) return 0
      return Math.min(
        100,
        round(multiply(divide(this.summaryTotalVolume, this.summaryTotalVolumeLimit), 100), 0)
      )
    },
    summaryWeightPct() {
      if (!this.summaryTotalWeightLimit) return 0
      return Math.min(
        100,
        round(multiply(divide(this.summaryTotalGrossWeight, this.summaryTotalWeightLimit), 100), 0)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.container-summary {
  flex-shrink: 0;
  background: transparent;
  padding: 6px 12px;
}

.container-summary__items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
}

.container-summary__item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  flex: 0 1 auto;
  min-width: 0;
}

.container-summary__icon {
  font-size: 12px;
  color: #94a3b8;
  flex-shrink: 0;

  &.is-volume {
    color: #3b82f6;
  }

  &.is-weight {
    color: #10b981;
  }
}

.container-summary__label {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  flex-shrink: 0;
}

.container-summary__value {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  white-space: nowrap;
}

.container-summary__unit {
  font-size: 10px;
  font-weight: 400;
  color: #94a3b8;
}

.container-summary__divider {
  width: 1px;
  height: 20px;
  background: #e2e8f0;
  flex-shrink: 0;
}

.container-summary__pct {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  margin-left: 4px;
}
</style>
